import { React, PropTypes, SelectRestaurantsListContainer as SelectRestaurantsList } from '../dependencies';
import Drawer from './Drawer';

const LeftPanel = ({ open, onClose }) => (
    <Drawer title="Dostupné restaurace" visible={open} onClose={onClose}>
        <SelectRestaurantsList />
    </Drawer>
);

LeftPanel.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

LeftPanel.defaultProps = {};

export default LeftPanel;
